import { engineBaseURL, engineClient } from './client';
import extractErrorMessage from '../utils/extractErrorMessage';

// AI summaries come from the AI engine, not the platform API. The engine keeps them
// current on its own; the dashboard only reads. `status` is returned so callers can tell
// "no access" (403) from "engine unreachable".

const notConfigured = {
  data: null,
  success: false,
  status: null,
  message: 'AI engine nije dostupan (nedostaje adresa API-ja).',
};

// Anything that isn't the engine's { success, data } shape (e.g. an HTML fallback page when
// the URL points at the wrong server) counts as a failure.
const checked = (body) =>
  body && typeof body.success === 'boolean'
    ? body
    : { ...notConfigured, message: 'AI engine je vratio neočekivan odgovor.' };

const failed = (error, fallback) => ({
  data: null,
  success: false,
  status: error.response?.status ?? null,
  message: extractErrorMessage(error, fallback),
});

const aiSummaryApi = {
  fetchUserSummary: async (userId, version) => {
    if (!engineBaseURL) return notConfigured;
    try {
      const params = version ? { version } : undefined;
      return checked(
        (await engineClient.get(`/user-summaries/admin/${userId}`, { params }))
          .data
      );
    } catch (error) {
      return failed(error, 'AI sažetak nije dostupan.');
    }
  },

  // Each read that shows answers is written to the engine's access log.
  fetchUserHealth: async (userId) => {
    if (!engineBaseURL) return notConfigured;
    try {
      return checked(
        (await engineClient.get(`/user-summaries/admin/${userId}/health`)).data
      );
    } catch (error) {
      return failed(error, 'Zdravstveni podaci nisu dostupni.');
    }
  },
};

export default aiSummaryApi;
